"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var userActivityService_1 = __importDefault(require("../core/services/userActivityService"));
exports.default = (function (_a, inject) {
    var $axios = _a.$axios;
    inject("userActivity", new userActivityService_1.default($axios));
});
//# sourceMappingURL=userActivity.js.map